import {
    Schema
} from './Schema.js';

import {
    newValidator
} from './Validator.js';

import {
    DataSanitizer as Sanitizer
} from './DataSanitizer.js';
import {
    newGraph as Graph
} from './Graph.js';





// From _lodash
function getTag(value) {
    if (value == null) {
        return value === undefined ? '[object Undefined]' : '[object Null]'
    }
    return Object.prototype.toString(value)
}

// From _lodash
function isString(value) {
    const type = typeof value
    return type === 'string' || (type === 'object' && value != null && !Array.isArray(value) && getTag(value) == '[object String]')
}



function beSureIsObject(data) {
    if (typeof data === 'object') {
        return Array.isArray(data) ? {} : data;
    }
    return {}
}

function beSureIsArray(data) {
    if (typeof data === 'object') {
        return Array.isArray(data) ? data : [];
    }
    if (typeof data === 'string' || typeof data === 'number') {
        return [data];
    }
    return []
}






// controller: Ref to the controller obj (model instance 'wrapper') created by the BaseModel
function createModelFromData(controller, schemaWrapper, data) {

    var model = {};

    // Populate the model with data (but only if the data prop is a prop in the schema)
    for (let prop in data) {
        if (schemaWrapper.propExists(prop)) {
            model[prop] = data[prop]
        }
    }

    // If the model is empty (e.g. data passed in just has key(s) that do not exist in the schema), report/log error 
    // and return empty model
    if (Object.keys(model).length === 0) {
        BaseModel.reportError(new Error('None of the props in the data object exist in the schema.'));
        return model;
    }

    // For each prop in the model, check if it has linked props,
    // and each of those has linked props, etc. ...
    // ... i.e. do a BFS on each prop to get all props that need 
    // to be added to the model.
    // Note: The default callback function in Graph will work.
    var allLinkedProps = [];
    for (let prop in model) {
        var BFSresult = controller.graph.BFS(prop);
        allLinkedProps = [...allLinkedProps, ...BFSresult]
    }
    // allLinkedProps could very well have many dupes... that's ok... can optimize later (!)
    for (let prop of allLinkedProps) {
        // If prop is already on the model, leave it alone; otherwise, add the prop with value '' 
        if (model[prop] === undefined) {
            model[prop] = '';
        }
    }



    return model;
}


// Create the validation rules object from the schema
// Note: Validation rule on a schema property can be specified with either of these keywords:
//  1] validation ... or 
//  2] v (a shorthand version)
// Example:
//   name: {
//     validation: {
//         required: 'Name must be filled in.',
//     },
//   }
//  -- OR --
//   name: {
//     v: {
//         required: 'Name must be filled in.',
//     },
//   }
function createValidationRules(schemaWrapper, removeProps = []) {

    var validationRules = {}
    var useProps = schemaWrapper.getProps().filter(prop => !removeProps.includes(prop));

    useProps.forEach(prop => {
        if (schemaWrapper.hasValidationRule(prop)) {
            validationRules[prop] = schemaWrapper.getValidationRule(prop);
            if (schemaWrapper.validationRulePropExists(prop, 'type')) {
                if (!isString(validationRules[prop].type)) {
                    BaseModel.reportError(new Error(`Schema Definition Error: Prop: ${prop} : Value for 'type' must be a string.`));
                }
            }
        }
    });

    return validationRules;
}

// Custom model: Created where THIS function is called, i.e. in wrapper instance update() method
function createValidationRulesForUpdate(model, validationRules) {
    var vRules = {};
    for (let prop in model) {
        if (validationRules[prop] !== undefined) {
            vRules[prop] = validationRules[prop]
        }
    }
    return vRules;
}

function createGraph(schema) {
    var g = Graph();
    var linkedProps = {};
    for (let prop in schema) {
        g.addVertex(prop);
        if (schema[prop].linked !== undefined) {
            var linkedTo = schema[prop].linked;
            linkedTo = Array.isArray(linkedTo) ? linkedTo : [linkedTo];
            linkedProps[prop] = linkedTo
        }
    }

    for (let p in linkedProps) {
        for (let x of linkedProps[p]) {
            try {
                g.addEdge(p, x);
            } catch (err) {
                BaseModel.reportError(new Error(`Schema Graph Error: Prop: ${p} : Linked to prop ${x} : ${x} does not exist.`));
            }
        }
    }
    // console.log(linkedProps)
    return g;
}



function createModel(schemaWrapper, removeProps = []) {
    var model = {};

    var useProps = schemaWrapper.getProps().filter(prop => !removeProps.includes(prop));

    useProps.forEach(prop => {
        var schemaDefaultVal = schemaWrapper.getProp(prop).default;
        var modelDefaultVal = schemaDefaultVal === undefined ? '' : schemaDefaultVal;
        model[prop] = modelDefaultVal;
    })

    return model;
}

// processContextSetting(controller, schema,obj.context);
// contextSetting: Single context might be a string; multiple contexts, this is an array where each element is a context value, e.g. ['frontend','backend']
// Modifies the model and associated validation rules to match the context settings.
// Leaves the orig model and validation rules intact; stores mods in their own controller properties: contextModel, contextValidationRules
function onSetContext(controller, schemaWrapper, contextSetting) {

    contextSetting = beSureIsArray(contextSetting);
    if (contextSetting.length === 0) return;

    // The schema properties that have a context setting matching any of those in contextSetting arg
    var contextProps = [];

    // For collecting/tracking errors when examining the schema for a context in contextSetting
    var contextSettingsErrors = []

    // Overall procedure: 
    // Create a new model with ONLY those props in the schema that have matching context to any contexts passed in.
    //  Examine schema; get list of matching props
    //  Track each passed in prop -- if it doesn't have a match in the schema, log the error.
    //      If there are any error in the log, throw error to end function (BEFORE creating new model and associated validation rules) and to alert user.
    //  Any OTHER schema props need to be ignored. Get/collect those 'unused' props.
    //  Call createModel() and createValidationRules() with the array of unused props. Set controller properties with objects returned from those calls.
    contextSetting.forEach(context => {

        // test...
        // schemaWrapper.getProps().forEach(prop => {
        //     console.log(prop, schemaWrapper.hasContext(prop, context, true));
        // });

        // NOTE: schemaWrapper.hasContext(prop,context) : If context is undefined, will return true IF there's a context prop on the schema prop.
        // So, that schema prop would get added to our schemaPropsWithContext array EVEN IF the prop's context doesn't match the current
        // context being checked in this loop.
        // So, check if context is NOT undefined ...
        if (context !== undefined) {
            // Gather all props from the schema that have a context value that matches context; remove all others.
            var schemaPropsWithContext = schemaWrapper.getProps().filter(prop => schemaWrapper.hasContext(prop, context, true));
            if (schemaPropsWithContext.length === 0) {
                contextSettingsErrors.push(context)
            }
            // Aggregate the props found in the schema that have the current context value
            // Will contain dupes+ if a schema prop has more than one context defined and two or more of THOSE context values are 
            // in the contextSetting arg ... okay if have dupes since the way this array will be used farther down.
            contextProps = [...contextProps, ...schemaPropsWithContext];
        }
    })
    // console.log('contextProps', contextProps);

    // If contextProps is empty, it means all the context values in the contextSetting array do not exist 
    // in the schema, e.g. typo at the call site (where user entered settings), etc.
    // This means ignoreProps, below, will end up with ALL the props; the resulting model in the subsequent createModel() call 
    // will be an empty object; same with contextValidationRules.
    // SO: Alert user there's an issue...
    if (contextSettingsErrors.length) {
        throw new Error(`Context setting error: The following contexts do not exist in the schema: ${contextSettingsErrors.join(', ')}. The context model and validation rules were not created.`);
    }

    // If contextProps is empty, it also means the contextSetting arg is an array with just elements set to undefined (wise guy user!).
    // Return if this is the case.
    if (contextProps.length === 0) return;

    // Get array of props that will NOT be included in the new contextModel and contextValidationRules that will be created following this line:
    var ignoreProps = schemaWrapper.getProps().filter(prop => !contextProps.includes(prop));

    // Create 'context model', i.e. model that reflects the context that's a DIFFERENT obj from the this.model object
    controller.contextModel = createModel(schemaWrapper, ignoreProps);

    // Create 'context validation rules', i.e. rules that reflect the context that's a DIFFERENT obj from the this.validationRules object
    controller.contextValidationRules = createValidationRules(schemaWrapper, ignoreProps);
}


// onSetPropLabels(schemaWrapper, obj.propLabels)
function onSetPropLabels(controller, schemaWrapper, propLabelsSetting) {
    Object.keys(propLabelsSetting).forEach(prop => {
        if (typeof propLabelsSetting[prop] === 'string') {
            schemaWrapper.setLabel(prop, propLabelsSetting[prop]);
        }
    })
    controller.validator.propLabel = schemaWrapper.createPropMap('label', 'getLabel');
}


function reportSetupErrors(modelName, errMsgPrefix) {
    try {
        if (BaseModel.setupErrors.length > 0) {
            throw new Error(`Setup Error(s) detected: Model Name: ${modelName}`);
        }
    } catch (err) {
        console.error(err);
        BaseModel.setupErrors.forEach(error => console.error(errMsgPrefix, error))
        return true;
    }
    return;
}





var BaseModel = {

    setupErrors: [],
    reportError: function (errMsg) {
        this.setupErrors.push(errMsg);
    },

    make: function (modelName, schema, api = {}, customProps = {}, customValidationRules = {}) { // model is the data (just the data) describing the object being created

        api = beSureIsObject(api);
        customProps = beSureIsObject(customProps);
        customValidationRules = beSureIsObject(customValidationRules);

        var schemaWrapper = Schema(schema);

        var model = createModel(schemaWrapper);

        var validationRules = createValidationRules(schemaWrapper);
        if (reportSetupErrors(modelName, 'Validation rules set not created:')) {
            return {}
        }


        var Validator = newValidator();

        Validator.customRules = Object.assign({}, customValidationRules);

        var graph = createGraph(schema);
        if (reportSetupErrors(modelName, 'Schema graph not created:')) {
            return {}
        }

        // Find and store all contexts defined in the schema, if any.
        // Gets set below in the controller obj.
        var contexts = schemaWrapper.getAllContexts();

        // For each prop in schema, extract the value of its 'truncate' property 
        // if it has one and store in object where each key is a prop name names and 
        // each value is the associated value of the prop's 'truncate' value.
        var truncates = schemaWrapper.getAllTruncates();

        // Create propLabel object, i.e. maps prop name to its 'human-readable' label, e.g. propLabel['fName'] = 'First Name'
        // The label is the 'label' property of each prop object in the schema.
        // If no label, the prop name is used: propLabel['uid'] = 'uid'
        // Validator expects this property - it's used in error reporting during validation -- so assign it.
        var propLabel = schemaWrapper.createPropMap('label', 'getLabel');
        Validator.propLabel = propLabel;


        // // TESTING -------------------------
        // console.log('VALIDATOR', Validator);
        // Validator.validate({ fName: 'GP' }, validationRules);
        // console.log(Validator.errorMsgs);
        // console.log('VALIDATOR', Validator);
        // // ---


        // Used in defineProperty
        var settings = {};

        // The object returned...
        var controller = {

            // Validation-related setting in validation prop.
            // All other Controller-related settings in 'top' level of this obj.
            settings: { // Controlled via defineProperty setter/getter

            },
            schema,
            model,
            validator: Validator,
            validationRules,
            graph,
            contexts,
            truncates,
            // propLabel,
            contextModel: null,
            contextValidationRules: null,

            config: function (configObj) {
                this.settings = configObj; //{ ...configObj }
            },

            create: function (data, createBasic) {
                data = beSureIsObject(data);
                var modelInstance = createBasic ? {} : Object.create(api);
                Object.assign(modelInstance, model);
                this.init(modelInstance, data)

                for (let prop in customProps) {
                    customProps[prop](modelInstance);
                }
                return modelInstance; // model populated with data, with api as the prototype
            },

            // For a 'full' set operation on the entire model (less any filtering via context, but even 'within' a given context,
            // a data object with ALL of the 'filtered down' props must be in the data obj since validation will be done in cases 
            // where validation rules are defined in the schema on some/most/all of those props).
            // Alternative: See the update() method below, where you passed-in obj contains JUST those props you want to update, i.e. 
            // you don't NEED all other props present. Useful for passing to a Firebase Firestore .update() method.
            set: function (data) {
                data = beSureIsObject(data);
                var useModel = this.contextModel ? this.contextModel : this.model;
                var useValidationRules = this.contextValidationRules ? this.contextValidationRules : this.validationRules;
                var modelInstance = Object.create(api);
                Object.assign(modelInstance, useModel);
                this.init(modelInstance, data);
                Validator.validate(modelInstance, useValidationRules);
                // console.log('Validator >>>>>>>>>>', Validator)
                return modelInstance;
            },

            // Set just those props present on the data obj (assuming, as with set() method, they are valid props per the schema).
            // For each prop present on the data obj, will automatically find all 'linked' properties and add them to the data obj so
            // so that validation will occur as it should, keeping the prop data consistent.
            update: function (data) {
                data = beSureIsObject(data);
                var model = createModelFromData(this, schemaWrapper, data);

                // If this new model is an empty obj, report error and return empty obj (validation check in caller will be falsey since validate 
                // isn't called (farther down)). Note: createModelFromData() will create/log this error if the model it creates is empty.
                if (reportSetupErrors(modelName, 'Model not created in update() method:')) {
                    return {}
                }
                var validationRules = createValidationRulesForUpdate(model, this.validationRules);
                // console.log('UPDATE val rules:', validationRules)
                // console.log('the model', model)
                this.init(model, data);
                Validator.validate(model, validationRules);
                return model;
            },

            // Get all props that are linked, i.e. where each prop in the returned array 
            // has a non-empty adjacency list.
            getAllLinkedProps: function () {
                return this.graph.getAllVerticies().filter(v => this.graph.hasAdjacentVerticies(v));
            },

            // For given prop, get its linked props. Returns array.
            getLinkedPropsForProp: function (prop) {
                return this.graph.getAdjacentVerticies(prop);
            },


            truncate: function (value, truncLen) {
                return Sanitizer.load(value).truncate(truncLen).getResult();
            },

            getPropTruncateLength: function (prop) {
                return this.truncates[prop];
            },


            validationPassed: function () {
                return Validator.validationPassed();
            },



            validationErrors: function () {
                return Validator.getErrors();
            },

            // param: error : An element (type array) of the errorMsgs array: Prop name is first element of the error array
            getErrorProp: function (error) {
                return Validator.getErrorProp(error);
            },

            // param: error : An element (type array) of the errorMsgs array: Property label is 2nd element of the error array
            getErrorPropLabel: function (error) {
                return Validator.getErrorPropLabel(error);
            },

            // param: error : An element (type array) of the errorMsgs array: Error message is 3rd element of the error array
            getErrorMsg: function (error) {
                return Validator.getErrorMsg(error);
            },



            // Creates/returns plain ol' object, i.e. no custom protoype (use case: Firebase Firestore needs a plain object as argument
            // to document add/set... a 'custom' object throws an exception).
            // ALSO: Could call 'create' then call getSnapshot with the instance and use the
            // object returned from THAT for use as the object argument in Firestore add/set.
            createBasic: function (data) {
                return this.create(data, true)
            },

            // Given a model "instance", return a new "plain ol'" object (i.e. no custom prototype) representing that same data (i.e. no methods, just data)
            getSnapshot: function (modelInstance) {
                return Object.assign({}, modelInstance)
            },

            // Param: model: An "dry" model instance, i.e. the "raw" model populated with its default values, ready to accept custom user form data.
            // Here in init(), it gets fleshed out with data provided by the object: data
            init: function (model, data) {
                Object.keys(model).forEach(prop => { // any prop in data obj that's NOT in the model (schema) is ignored

                    // ESLint error when using: data.hasOwnProperty(prop)...
                    // >> https://eslint.org/docs/rules/no-prototype-builtins
                    // if (data.hasOwnProperty(prop)) {
                    if (Object.prototype.hasOwnProperty.call(data, prop)) {
                        model[prop] = Sanitizer.load(data[prop]).trim().truncate(this.getPropTruncateLength(prop)).escapeHTML().normalizeEmail().getResult()
                    }
                    // if (data.hasOwnProperty(prop)) {
                    //     model[prop] = data[prop]
                    // } else {
                    //     if (typeof model[prop] === 'object') {
                    //         if (Array.isArray(model[prop])) {
                    //             model[prop] = []
                    //         } else {
                    //             model[prop] = Object.assign({}, model[prop])
                    //         }
                    //     }
                    // }

                    // For any value that is undefined, transform it to an empty string (use case: this satisfies Firebase Firestore that will
                    // reject (i.e. throw exception) during document add/set if any field in the passed-in object has a value of undefined).
                    // *** NOTE: Using == (not ===) since this operator against undefined will also return true if comparing to null
                    // (whereas === will strictly "find" undefined as true and null as false)...
                    // So, here a model property with value of null will also get changed to an empty string.
                    if (model[prop] == undefined) {
                        model[prop] = ''
                    }

                });
            },


            // Return the "base" "empty" model (i.e. created from the model's schema, using defaults set there, etc.).
            // Useful if need to create a model object "intance" (i.e. populate with data) OUTSIDE
            // of this BaseModel module.
            getModel: function () {
                return model;
            }

        }

        Object.defineProperty(controller, 'settings', {
            get: function () {
                return settings
            },
            set: function (obj) {
                obj = beSureIsObject(obj);
                // settings = obj; // No: Any obj passed in to config() will end up in settings
                if (obj.context) {
                    settings.context = obj.context;
                    try {
                        onSetContext(controller, schemaWrapper, obj.context, modelName);
                    } catch (err) {
                        console.error(err)
                    }
                }
                if (obj.propsOrder) {
                    controller.validator.config('propsOrder', obj.propsOrder)
                }
                if (obj.verbose !== undefined) {
                    controller.validator.config('verbose', obj.verbose)
                }
                if (obj.doTypeCheck !== undefined) {
                    controller.validator.config('doTypeCheck', obj.doTypeCheck);
                }
                if (obj.propLabels !== undefined) {
                    onSetPropLabels(controller, schemaWrapper, obj.propLabels);
                }
            }
        });

        return controller;
    },

}


export {
    BaseModel
};